import React, { HTMLAttributes } from "react";
import cn from "classnames";

export type CardBodyProps = HTMLAttributes<HTMLDivElement>;

export const CardBody = (props: CardBodyProps) => {
  const { className, ...rest } = props;
  return <div className={cn("card-body", className)} {...rest} />;
};

export default CardBody;
